<template>
    <div class="page-wrapper">
        <page-header class="page-head"></page-header>
        <!-- 对应的组件内容渲染到router-view中 -->
        <!--<keep-alive>-->
            <router-view></router-view>
        <!--</keep-alive>-->
    </div>
</template>

<script>
    import PageHeader from "../../components/topHead.vue";

    export default {
        name: "index",
        data () {
            return {};
        },
        components: {
            PageHeader
        }
    };
</script>

<style lang="scss" scoped>
</style>
